import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IPoolData {
  pool_id: string,
  pool_name: string,
  area_id: string
}
export interface IGetPoolsResponse {
  list_pool: IPoolData[]
}
export interface IGetCompaniesByPoolResponse {
  pool: {
    pool_code: string,
    pool_name: string
  },
  list_company: {
    company_id: string,
    company_name: string,
  }[]
}

const url = "/v1/pool";

export const getPools = async (): Promise<IGetPoolsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/BB`,
    method: "GET",
  });

  return data;
};

export const getPoolsByArea = async (areaId: string): Promise<IGetPoolsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/areaid/${areaId}`,
    method: "GET",
  });

  return data;
};

export const getCompaniesByPool = async (poolId: string): Promise<IGetCompaniesByPoolResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/company/${poolId}`,
    method: "GET",
  });

  return data;
};
